<template>
	<div>
		<h1><translate>{{ title }}</translate></h1>
		<fieldset>
			<legend>
				<img src="/bo/images/icons/table_save.png">
				<translate>Reports</translate>
			</legend>

			<div v-if="list === 'Claims'">
				<v-list-item v-if="validatePermission('export.claims.details')">
					<a href="/bo/report/claims/details"><translate>Claim Details</translate></a>
				</v-list-item>
				<v-list-item v-if="validatePermission('export.claims.details')">
					<a href="/bo/report/claims/claimquestionresponses"><translate>Claim Question Responses</translate></a>
				</v-list-item>
				<v-list-item v-if="validatePermission('export.claims.overview')">
					<a href="/bo/report/claims/overview"><translate>Claims Overview</translate></a>
				</v-list-item>
				<v-list-item v-if="validatePermission('export.reviewedclaims')">
					<a href="/bo/report/export/reviewedclaims"><translate>Reviewed Claims</translate></a>
				</v-list-item>
				<v-list-item v-if="validatePermission('export.claimevents.reviewtimes')">
					<a href="/bo/report/export/claimevents/reviewtimes"><translate>Review Times</translate></a>
				</v-list-item>
			</div>

			<div v-if="list === 'CustomerService'">
				<v-list-item v-if="validatePermission('export.orders')">
					<a href="/bo/report/export/orders"><translate>Orders</translate></a>
				</v-list-item>
				<v-list-item v-if="validatePermission('export.orders')">
					<a href="/bo/report/export/orders/rejected"><translate>Rejected Orders</translate></a>
				</v-list-item>
				<v-list-item v-if="validatePermission('export.orders.overview')">
					<a href="/bo/report/export/orders/overview"><translate>Orders Overview</translate></a>
				</v-list-item>
				<v-list-item v-if="validatePermission('export.manualorders')">
					<a href="/bo/report/export/manualorders"><translate>Manually Insured Policies</translate></a>
				</v-list-item>
				<v-list-item v-if="isAdmin === '1'">
					<a href="/bo/report/export/devices"><translate>Manage Devices</translate></a>
				</v-list-item>
				<v-list-item v-if="validatePermission('export.claimlimit')">
					<a href="/bo/report/customerservice/claimlimit"><translate>Claim limit</translate></a>
				</v-list-item>
				<v-list-item v-if="validatePermission('export.pos.customerservice')">
					<a href="/bo/report/customerservice/reviewinvites"><translate>Review Invites</translate></a>
				</v-list-item>
				<v-list-item v-if="validatePermission('export.pos.customerservice')">
					<a href="/bo/report/customerservice/reasonfortermination"><translate>Reason for termination</translate></a>
				</v-list-item>
				<v-list-item v-if="validatePermission('export.pos.customerservice')">
					<a href="/bo/report/customerservice/sentemails"><translate>Sent emails</translate></a>
				</v-list-item>
			</div>

			<div v-if="list === 'ReturnRepair'">
				<v-list-item v-if="validatePermission('export.claims.repairdata')">
					<a href="/bo/report/returnrepair/repairdata"><translate>Claims Repair Details</translate></a>
				</v-list-item>
				<v-list-item v-if="validatePermission('export.replacedphones')">
					<a href="/bo/report/export/replacedphones"><translate>Replaced Phones</translate></a>
				</v-list-item>
			</div>

			<div v-if="list === 'Finance'">
				<v-list-item v-if="validatePermission('export.transactions')">
					<a href="/bo/report/finance/transactionreserves"><translate>Customer Balances</translate></a>
				</v-list-item>
				<v-list-item v-if="validatePermission('export.claimreserves')">
					<a href="/bo/report/export/claimreserves"><translate>Claim Reserves Status</translate></a>
				</v-list-item>
				<v-list-item v-if="validatePermission('export.claimreserves')">
					<a href="/bo/report/export/claimmutations"><translate>Claim Reserve Changes</translate></a>
				</v-list-item>
				<v-list-item v-if="validatePermission('export.claimdamages')">
					<a href="/bo/report/export/damages"><translate>Claim Damage Records</translate></a>
				</v-list-item>
				<v-list-item v-if="validatePermission('export.payments')">
					<a href="/bo/report/export/payments/daterange"><translate>Linked Payments</translate></a>
				</v-list-item>
				<v-list-item v-if="validatePermission('export.payments')">
					<a href="/bo/report/export/payments/nobookdate"><translate>Debits in Progress</translate></a>
				</v-list-item>
				<v-list-item v-if="validatePermission('export.invoicerows')">
					<a href="/bo/report/export/invoicerows"><translate>Invoice Rows</translate></a>
				</v-list-item>
				<v-list-item v-if="validatePermission('export.transactions')">
					<a href="/bo/report/finance/transactions"><translate>Transactions</translate></a>
				</v-list-item>
				<v-list-item v-if="validatePermission('export.transactions')">
					<a href="/bo/report/finance/transactionfees"><translate>Transaction Fees</translate></a>
				</v-list-item>
				<v-list-item v-if="validatePermission('export.claimdamages')">
					<a href="/bo/report/finance/simpledamage"><translate>Simple damage rate</translate></a>
				</v-list-item>
				<v-list-item v-if="validatePermission('export.claimdamages')">
					<a href="/bo/report/finance/unpaidinvoices"><translate>Unpaid invoices</translate></a>
				</v-list-item>
				<v-list-item v-if="validatePermission('export.claimdamages')">
					<a href="/bo/report/finance/unpaidinvoicesreason"><translate>Unpaid invoices - reasons</translate></a>
				</v-list-item>
			</div>

			<div v-if="list === 'Store'">
				<v-list-item v-if="validatePermission('export.pos.store')">
					<a href="/bo/report/export/pos/store"><translate>Stores</translate></a>
				</v-list-item>
			</div>

			<div v-if="list === 'DataScience'">
				<v-list-item v-if="validatePermission('export.datascience')">
					<a href="/bo/report/datascience/claimreservechanges"><translate>Claim Reserve Changes</translate></a>
				</v-list-item>
				<v-list-item v-if="validatePermission('export.datascience')">
					<a href="/bo/report/datascience/claims"><translate>Claims Data</translate></a>
				</v-list-item>
				<v-list-item v-if="validatePermission('export.datascience')">
					<a href="/bo/report/datascience/policies"><translate>Policy Data</translate></a>
				</v-list-item>
				<v-list-item v-if="isAdmin">
					<a href="/bo/report/datascience/activepolicies"><translate>Active Policies</translate></a>
				</v-list-item>
				<v-list-item v-if="validatePermission('export.datascience')">
					<a href="/bo/report/datascience/claimevents"><translate>Claim Status Transitions</translate></a>
				</v-list-item>
				<v-list-item v-if="validatePermission('export.datascience')">
					<a href="/bo/report/datascience/policytransitions"><translate>Policy Transitions</translate></a>
				</v-list-item>
				<v-list-item v-if="validatePermission('export.datascience')">
					<a href="/bo/report/export/damages"><translate>Claim Damage Records</translate></a>
				</v-list-item>
				<v-list-item v-if="validatePermission('export.datascience')">
					<a href="/bo/report/datascience/paymentdata"><translate>Payment Data</translate></a>
				</v-list-item>
			</div>

			<div v-if="list === 'ProductMonitoringDashboard'">
				<v-list-item v-if="validatePermission('export.productmonitoringdashboard')">
					<a href="/bo/report/productmonitoringdashboard/policies"><translate>Policies</translate></a>
				</v-list-item>
				<v-list-item
					v-can="'export.productmonitoringdashboard'"
				>
					<a href="/bo/report/productmonitoringdashboard/claims">Claims</a>
				</v-list-item>
				<v-list-item v-can="'export.productmonitoringdashboard'">
					<a href="/bo/report/productmonitoringdashboard/lossratio">Loss Ratio</a>
				</v-list-item>
				<v-list-item v-can="'export.productmonitoringdashboard'">
					<a href="/bo/report/productmonitoringdashboard/productmonitoringdashboard"><translate>Product Monitoring Dashboard</translate></a>
				</v-list-item>
			</div>
		</fieldset>
	</div>
</template>

<script>
export default {
	name: 'ReportList',
	props: {
		permissions: {
			type: Object,
			required: true,
		},
		isAdmin: {
			type: String,
			required: true,
		},
		title: {
			type: String,
			required: true,
		},
		list: {
			type: String,
			required: true,
		},
	},
	methods: {
		/**
		 * @param {string} permission
		 * @returns {string|boolean}
		 */
		validatePermission (permission) {
			return this.isAdmin || permission in this.permissions;
		},
	},
};
</script>

<style scoped>

</style>
